import { Formatters } from '@billy/design-system'
import { Text, View } from '@react-pdf/renderer'
import { Trans } from 'react-i18next'

import { headerPdfStyles } from '@features/exports/utils/headerPdfStyles'

const dateOptions: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: '2-digit',
}

export const ExportHeaderPdf = ({
  organizationName,
  periodText,
  locale,
}: {
  organizationName?: string
  periodText: string
  locale?: string
}) => {
  const { container, metaText, metaWrapper, titleText, titleWrapper, dates } = headerPdfStyles

  const intlLocale = Formatters.getFormatLocale(locale ?? 'da_DK')
  const generatedAt = new Date()

  const generatedTimeFormatted = new Intl.DateTimeFormat(intlLocale, {
    ...dateOptions,
    hour: '2-digit',
    minute: '2-digit',
  }).format(generatedAt)

  return (
    <View style={container} fixed={true}>
      <View style={titleWrapper}>
        <Text style={titleText}>
          <Trans i18nKey="vat_declaration.export.header.title" values={{ period: periodText }} />
        </Text>
      </View>

      <View style={metaWrapper}>
        <View>{organizationName && <Text style={metaText}>{organizationName}</Text>}</View>

        <View>
          <Text style={[metaText, dates]}>
            <Trans
              i18nKey="vat_declaration.export.header.generated_time"
              values={{ generatedTime: generatedTimeFormatted }}
            />
          </Text>
        </View>
      </View>
    </View>
  )
}
